(function () {
  function normalizedText(value) {
    return value.replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function rebuildListRow(paragraph, markerText, className) {
    const markerSource = paragraph.firstElementChild;
    if (!markerSource) return;

    const bodyNodes = [];
    let markerFound = false;

    for (const node of Array.from(paragraph.childNodes)) {
      if (node === markerSource) {
        markerFound = true;
        continue;
      }

      if (!markerFound && node.nodeType === Node.TEXT_NODE && !normalizedText(node.textContent || '')) continue;
      if (markerFound) bodyNodes.push(node);
    }

    const marker = document.createElement('span');
    marker.className = 'policy-list-marker';
    marker.textContent = markerText;

    const content = document.createElement('span');
    content.className = 'policy-list-content';
    content.replaceChildren(...bodyNodes);

    paragraph.classList.add(className);
    paragraph.replaceChildren(marker, content);
  }

  function firstMeaningfulChild(container) {
    return Array.from(container.children).find((el) => {
      if (!(el instanceof HTMLElement) || el.hidden) return false;
      return Boolean(normalizedText(el.textContent || ''));
    });
  }

  function normalizePolicyHeader(shell) {
    const title = normalizedText(shell.dataset.pageTitle || '');
    const subtitleEl = shell.querySelector('[data-policy-subtitle]');
    const rte = shell.querySelector('.rte');
    if (!rte) return;

    let node = firstMeaningfulChild(rte);
    if (node && node.tagName === 'DIV') {
      const inner = firstMeaningfulChild(node);
      if (inner) node = inner;
    }
    if (node && /^(H1|H2)$/.test(node.tagName) && title && normalizedText(node.textContent || '') === title) {
      node.hidden = true;
      node = firstMeaningfulChild(node.parentElement || rte);
      if (node && node.tagName === 'DIV') {
        const inner = firstMeaningfulChild(node);
        if (inner) node = inner;
      }
    }

    if (!node || node.tagName !== 'P') return;

    const text = normalizedText(node.textContent || '');
    const existingSubtitle = subtitleEl ? normalizedText(subtitleEl.textContent || '') : '';
    const looksLikeLead =
      text.length > 0 &&
      text.length <= 160 &&
      !/^effective date/i.test(text) &&
      !/^\d+\./.test(text) &&
      !node.querySelector('strong, b, em, a, ul, ol');

    if (existingSubtitle && text === existingSubtitle) {
      node.hidden = true;
      return;
    }

    if (!existingSubtitle && looksLikeLead && subtitleEl instanceof HTMLElement) {
      subtitleEl.textContent = text;
      subtitleEl.hidden = false;
      node.hidden = true;
    }
  }

  function normalizePolicyContent() {
    const scrollX = window.scrollX;
    const scrollY = window.scrollY;

    document.querySelectorAll('.shopify-policy-page-shell').forEach((shell) => {
      if (shell instanceof HTMLElement) normalizePolicyHeader(shell);
    });

    document.querySelectorAll('.shopify-policy-page-shell .rte').forEach((container) => {
      if (container.dataset.policyContentNormalized === 'true') return;
      container.dataset.policyContentNormalized = 'true';

      container.querySelectorAll('p.MsoNormal').forEach((paragraph) => {
        const text = normalizedText(paragraph.textContent || '');

        if (!text) {
          paragraph.hidden = true;
          return;
        }

        const sectionMatch = text.match(/^(\d+\.)\s+(.+)$/);
        if (sectionMatch && paragraph.querySelector('b, strong')) {
          rebuildListRow(paragraph, sectionMatch[1], 'policy-section-heading');
          return;
        }

        const numberedMatch = text.match(/^(\d+\.\d+\.)\s+(.+)$/);
        if (numberedMatch) {
          rebuildListRow(paragraph, numberedMatch[1], 'policy-numbered-item');
          return;
        }

        const bulletMatch = text.match(/^▪\s*(.+)$/);
        if (bulletMatch) {
          rebuildListRow(paragraph, '▪', 'policy-bullet-item');
          return;
        }

        if (paragraph.querySelector('b, strong') && text === text.toUpperCase()) {
          paragraph.classList.add('policy-content-heading');
        }
      });
    });

    if (window.scrollX !== scrollX || window.scrollY !== scrollY) {
      window.scrollTo(scrollX, scrollY);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', normalizePolicyContent, { once: true });
  } else {
    normalizePolicyContent();
  }
})();
